// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__qGhUj","title":"Header_title__3Kbsu","side":"Header_side__2aVV8"};